import { useState } from "react";

const initials = (name: string) =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();

interface ChatAvatarProps {
  name: string;
  imageUrl?: string;
  isOnline?: boolean;
  sizeClass?: string;
}

const ChatAvatar = ({ name, imageUrl, isOnline, sizeClass = "h-11 w-11 text-sm" }: ChatAvatarProps) => {
  const [failedImageUrl, setFailedImageUrl] = useState<string>();
  const hasImage = Boolean(imageUrl) && imageUrl !== failedImageUrl;

  return (
    <span
      aria-hidden="true"
      className={`relative flex shrink-0 items-center justify-center rounded-full bg-linear-to-br from-(--brand-primary)/50 to-(--brand-primary)/10 font-semibold text-(--brand-primary-hover) shadow-md shadow-black/30 ring-1 ring-(--brand-primary)/40 ${sizeClass}`}
    >
      {hasImage ? (
        <img
          src={imageUrl}
          alt=""
          onError={() => setFailedImageUrl(imageUrl)}
          className="h-full w-full rounded-full object-cover"
        />
      ) : (
        initials(name)
      )}
      {isOnline && (
        <span className="absolute right-0 bottom-0 flex h-3 w-3">
          <span className="absolute inset-0 animate-ping rounded-full bg-emerald-400/70 motion-reduce:animate-none" />
          <span className="relative h-3 w-3 rounded-full border-2 border-(--app-raised) bg-emerald-400" />
        </span>
      )}
    </span>
  );
};

export default ChatAvatar;
